import { HomePage  } from './pages';
import HizmetForm from "./pages/hizmetform/HizmetForm.js";
import AsgariUcretTanim from "./pages/asgariucrettanim/AsgariUcretTanim.js";
import GostergeTanim from "./pages/gosterge/Gosterge";
import Gosterge4bTanim from "./pages/gosterge4b/Gosterge4b";
import KazancTanim from "./pages/kazanc/Kazanc";
import HesapForm from "./pages/hesap/HesapForm.js";
import EnflasyonTanimForm from "./pages/enflasyontanim/EnflasyonTanim.js";
import KullaniciHesap from "./pages/kullanicihesap/KullaniciHesap";
import EmeklilikKosul from "./pages/emeklilikkosul/EmeklilikKosul.js";

export default   [
  {
    path: '/home',
    component: HomePage
  }, 
  {
    path: '/AsgariUcretTanim',
    component: AsgariUcretTanim
  },  
  {
    path: '/GostergeTanim',
    component: GostergeTanim
  }, 
  {
    path: '/Gosterge4bTanim',
    component: Gosterge4bTanim
  }, 
  { 
    path: '/KazancTanim',
    component: KazancTanim
  },
  { 
    path: '/EnflasyonTanim',
    component: EnflasyonTanimForm
  },
  { 
    path: '/EmeklililikKosul',
    component: EmeklilikKosul
  },
  {
    path: '/hizmetForm',
    component: HizmetForm
  },
  {
    path: '/HesapForm',
    component: HesapForm
  },
  {
    path: '/KullaniciHesap',
    component: KullaniciHesap
  }
];

 
